const satisfactionSurveyMge = r => require.ensure([], () => r(require('@/page/satisfactionSurvey/satisfactionSurveyMge')), 'satisfactionSurveyMge');

const templateMge = r => require.ensure([], () => r(require('@/page/satisfactionSurvey/templateMge/templateMge')), 'templateMge');
const surveyMge = r => require.ensure([], () => r(require('@/page/satisfactionSurvey/satisfactionMge/surveyMge')), 'surveyMge');
const addMge = r => require.ensure([], () => r(require('@/page/satisfactionSurvey/addMge/addMge')), 'addMge');
const satisfactionMge = r => require.ensure([], () => r(require('@/page/satisfactionSurvey/satisfactionMge/satisfactionMge')), 'satisfactionMge');
const satisfactionMgeDetail = r => require.ensure([], () => r(require('@/page/satisfactionSurvey/satisfactionMge/satisfactionMgeDetail')), 'satisfactionMgeDetail'); //满意度详情



const satisfactionSurveyRouter = {
  path: '',
  component: satisfactionSurveyMge,
  meta: {
    icon: 'satisfactionSurvey',
    right: [],
    isShowMenu: true,
    keepAlive:true
  },
  name: '满意度调查',
  children: [{
      path: '/templateMge',
      component: templateMge,
      name: '满意度模板管理',
      meta: {
        right: ['满意度调查模板管理'],
        isShowMenu: true,
        keepAlive:true
      },
    },
    {
      path: '/addMge',
      component: addMge,
      name: '发起满意度调查',
      meta: {
        right: ['满意度调查发起'],
        isShowMenu: true,
        keepAlive:true
      },
    },
    {
      path: '/satisfactionMge',
      component: satisfactionMge,
      name: '满意度调查详情',
      meta: {
        right: ['满意度调查详情'],
        isShowMenu: false,
        keepAlive: false
      },
    },
    {
      path: '/surveyMge',
      component: surveyMge,
      name: '满意度调查管理',
      meta: {
        right: ['满意度调查管理'],
        isShowMenu: true,
        keepAlive:true
      },
    },
    {
      path: '/satisfactionMgeDetail',
      component: satisfactionMgeDetail,
      name: '满意度详情',
      meta: {
        right: ['满意度详情'],
        isShowMenu: false,
        keepAlive:true
      },
    }, //满意度详情

    // {path:'/organMgeInfo',component:organMgeInfo,name:'机构详情',meta: {right: ['admin'],isShowMenu:true},}
  ]
};

export default satisfactionSurveyRouter;
